module.exports = __webpack_public_path__ + "static/img/canSAR_logo_0913_alpha_500x326.bbfb70f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/canSAR_logo_0913_alpha_500x326.png
// module id = 202
// module chunks = 1